export default __webpack_public_path__ + "static/media/sucodelaranja.483f4738.jpeg";